import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { MAX_BOOK_COVER_MB, MAX_BOOK_PDF_MB } from "utils";

export const DEFAULT_BULK_IMPORT_LIMITS = {
	max_items: 50,
	max_active_per_publisher: 2,
	max_manifest_mb: 5,
	max_batch_mb: 5000,
	max_cover_mb: MAX_BOOK_COVER_MB,
	max_pdf_mb: MAX_BOOK_PDF_MB,
	cover_mimes: ["jpeg", "jpg", "png", "webp"],
	pdf_mimes: ["pdf"],
	manifest_mimes: ["xlsx", "csv", "xls"],
};

const useBulkImportLimits = () => {
	const { accessToken } = useTokenStore();

	return useQuery(
		["bulkBookImportLimits"],
		async () => {
			const instance = await InitApi({ accessToken });
			const response = await instance.get(
				"/publisher/bulk-book-imports/limits"
			);
			return {
				...DEFAULT_BULK_IMPORT_LIMITS,
				...(response.data?.data || {}),
			};
		},
		{
			staleTime: 5 * 60 * 1000,
			placeholderData: DEFAULT_BULK_IMPORT_LIMITS,
		}
	);
};

export default useBulkImportLimits;
